module.exports = "/images/redMopedLoading.png";